import React from "react";
import styles from "./DatePicker.module.css";
import PropTypes from "prop-types";

/**
 * An interactive component that allows user to type in a date
 * Accepts dateString as value; updated through a setDate function
 */

export function DatePicker({ dateString, setDate, toggleCalendar, readOnly = false }) {
  return (
    <div className={styles.container}>
      <input
        readOnly={readOnly}
        type="text"
        value={dateString}
        onChange={(key) => setDate(key.target.value)}
        className={styles.input}
        placeholder="MM.DD.YY"
      ></input>
      <div
        className={styles.icon}
        onClick={() => {
          if(toggleCalendar && !readOnly){
            toggleCalendar();
          }
        }}
      >
        <div className={styles.calendar} />
        <div className={styles.calendarTop} />
      </div>
    </div>
  );
}

DatePicker.propTypes = {
  // current date being displayed
  dateString: PropTypes.string,

  // function used to set date
  setDate: PropTypes.func,
};
